import {Nut_WebFx_Mcfx_Enrichment_Actions_GetAccountEnrichmentData as SettingsConstants} from 'nutshell-core/settings-constants';

import {useGetSetting} from '../../core/use-get-setting';

import {IS_PEOPLE_IQ_DISABLED} from './people-iq-page';

export function useGetPeopleIqSettings() {
    const {setting: nutshellIntelligenceSetting, isLoading: nutshellIntelligenceSettingLoading} =
        useGetSetting({
            settingName: SettingsConstants.NUTSHELL_INTELLIGENCE_DISABLED_SETTING_NAME,
            isGlobal: true,
        });
    const isNutshellIntelligenceDisabled =
        nutshellIntelligenceSetting && nutshellIntelligenceSetting.value;

    const {
        setting: intelligenceForCompaniesSetting,
        isLoading: intelligenceForCompaniesSettingLoading,
    } = useGetSetting({
        settingName: SettingsConstants.ENRICHMENT_DISABLED_SETTING_NAME,
        isGlobal: true,
    });
    const isIntelligenceForCompaniesDisabled =
        intelligenceForCompaniesSetting && intelligenceForCompaniesSetting.value;

    const {setting: peopleIqSetting, isLoading: peopleIqSettingLoading} = useGetSetting({
        settingName: IS_PEOPLE_IQ_DISABLED,
        isGlobal: true,
    });
    const isPeopleIqDisabled = peopleIqSetting && peopleIqSetting.value;

    const isLoading =
        nutshellIntelligenceSettingLoading ||
        intelligenceForCompaniesSettingLoading ||
        peopleIqSettingLoading;

    return {
        isIntelligenceForCompaniesDisabled,
        isNutshellIntelligenceDisabled,
        isPeopleIqDisabled,
        isLoading,
    };
}
